/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtextitalic2Inputs */

const en_richtextitalic2 = /** @type {(inputs: Richtextitalic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italic`)
};

const de_richtextitalic2 = /** @type {(inputs: Richtextitalic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursiv`)
};

/**
* | output |
* | --- |
* | "Italic" |
*
* @param {Richtextitalic2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtextitalic2 = /** @type {((inputs?: Richtextitalic2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtextitalic2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtextitalic2(inputs)
	return de_richtextitalic2(inputs)
});
export { richtextitalic2 as "richTextItalic" }